import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

// Uses useEffect (not useLayoutEffect) to run AFTER useUrlToGlobalTerminalSync,
// preventing race conditions where URL sync would be immediately cleared
export const useClearUrlOnTerminalChange = (
  globalTerminalId: number | undefined,
  urlSelectedTerminalId: number | null,
  isApplyingUrlTerminal: React.MutableRefObject<boolean>
) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (isApplyingUrlTerminal.current) {
      isApplyingUrlTerminal.current = false;
      return;
    }

    if (
      globalTerminalId !== undefined &&
      urlSelectedTerminalId !== null &&
      globalTerminalId !== urlSelectedTerminalId
    ) {
      history.push({
        pathname: location.pathname,
        search: "",
        hash: location.hash,
      });
    }
  }, [globalTerminalId, urlSelectedTerminalId, history, location, isApplyingUrlTerminal]);
};
